// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1596":"f499324b","3016":"f499324b","3359":"ba615f2f","3912":"ba615f2f","4522":"f499324b","6572":"ba615f2f","7399":"95572145","7779":"f499324b","9647":"ba615f2f"}[chunkId] + ".chunk.css";
};